<script setup>
import { currentUser } from "../db/auth.js";

defineProps({
  title: { type: String, default: "Dashboard" },
});

const emit = defineEmits(['toggle-sidebar']);

const user = currentUser();

function toggleSidebar() {
  emit('toggle-sidebar');
}
</script>

<template>
  <header class="topbar">
    <div class="left-section">
      <button class="toggle-btn" @click="toggleSidebar" aria-label="Toggle sidebar">
        <span class="material-symbols-rounded">menu</span>
      </button>
      <div class="page-title">{{ title }}</div>
    </div>
    <div class="top-actions">
      <button class="action-btn">
        <span class="material-symbols-rounded">notifications</span>
      </button>
    </div>
  </header>
</template>

<style scoped>
.topbar {
  height: 64px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
}

.left-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.toggle-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: transparent;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: var(--text);
  transition: all 0.2s ease;
}

.toggle-btn:hover {
  background: rgba(124, 92, 255, 0.1);
  border-color: rgba(124, 92, 255, 0.3);
  color: var(--accent);
}

.page-title {
  font-size: 1.2rem;
  font-weight: 700;
}

.top-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.action-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: transparent;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: var(--muted);
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: rgba(124, 92, 255, 0.1);
  border-color: rgba(124, 92, 255, 0.3);
  color: var(--accent);
}
</style>
